import { SHOW_TOAST } from "../actionTypes";

export const showToast = message => ({
  type: SHOW_TOAST,
  payload: message
})